import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Button, Modal } from "react-bootstrap";

interface IAppModal {
  
  showButtons: boolean;
  size: "sm" | "md" | "lg" | "xl"
  onClose: () => void;
  onDataAction?: (returndata: any) => void;
  title?: string;
  children?: ReactNode;
  dataActionButtonText?: string;
  actionButtonIcon?: IconDefinition;
  actionButtonVariant?: string;
  actionButtonClass?: string;
  cancelButtonText?: string;
  cancelButtonIcon?: IconDefinition;
  cancelButtonVariant?: string;
  cancelButtonClass?: string;
  fullScreen?: boolean;
  enableActionButton?: boolean;
  backdrop?: boolean | "static";
  modalClassName?: string;
  backdropClassName?: string;
}

const AppModal = ({ 
  title, 
  showButtons, 
  onClose, 
  onDataAction, 
  children, 
  size, 
  dataActionButtonText, 
  actionButtonIcon,
  actionButtonVariant,
  actionButtonClass,
  cancelButtonText,
  cancelButtonIcon,
  cancelButtonVariant,
  cancelButtonClass,
  fullScreen,
  enableActionButton,
  backdrop,
  modalClassName,
  backdropClassName }: IAppModal) => {

  const actionEnabled: boolean = enableActionButton ?? true;

  return (
    <Modal 
      show 
      onHide={onClose} 
      backdrop={backdrop ?? "static"} 
      size={size === "md" ? undefined : size} 
      className={`app-modal mt-0 pt-0 ${modalClassName ?? ""}`.trim()}
      backdropClassName={backdropClassName}
      dialogClassName="app-modal__dialog"
      fullscreen={fullScreen === true ? true : undefined}
      autoFocus={false}
      enforceFocus={false}>
      
      <Modal.Header closeButton className="app-modal__header">
        {title && (
          <div className="app-modal__title-wrap">
            <div className="app-modal__eyebrow">Details</div>
            <Modal.Title className="app-modal__title" dangerouslySetInnerHTML={{ __html: title }}></Modal.Title>
          </div>
        )}
      </Modal.Header>
      
      <Modal.Body className="app-modal__body">
        {/* Render the children components passed inside <ModalDialogue></ModalDialogue> */}
        { children }
      </Modal.Body>
      
      {showButtons && (
        <Modal.Footer className="app-modal__footer">
          <Button variant={cancelButtonVariant ?? "secondary"} className={`app-modal__cancel ${cancelButtonClass ?? ""}`.trim()} onClick={onClose}>
            { cancelButtonIcon && (
              <FontAwesomeIcon icon={cancelButtonIcon} />
            )}
            {cancelButtonText ?? "Cancel"}
          </Button>

          { onDataAction && (
            <Button variant={actionButtonVariant ?? "primary"} className={`app-modal__action ${actionButtonClass ?? ""}`.trim()} onClick={onDataAction} disabled={!actionEnabled}>
              { actionButtonIcon && (
                <FontAwesomeIcon icon={actionButtonIcon} />
              )}
              { dataActionButtonText ?? "Save" }
            </Button>
          )}

        </Modal.Footer>
      )}
    </Modal>
  );
}

export default AppModal;
